import React from "react";
import { translations } from "../constants/translation";

const LanguageContext = React.createContext(undefined);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = React.useState("en");
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
    const savedLanguage = localStorage.getItem("hebe-language");
    if (savedLanguage && (savedLanguage === "en" || savedLanguage === "id")) {
      setLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = React.useCallback((newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem("hebe-language", newLanguage);
  }, []);

  const t = translations[language];

  const defaultValue = React.useMemo(
    () => ({ language: "en", changeLanguage, t: translations.en }),
    [changeLanguage]
  );

  const value = React.useMemo(
    () => ({ language, changeLanguage, t }),
    [language, changeLanguage, t]
  );

  // Return default language on server to avoid hydration mismatch
  if (!mounted) {
    return (
      <LanguageContext.Provider value={defaultValue}>
        {children}
      </LanguageContext.Provider>
    );
  }

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = React.use(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
